import {useOrdersHistory} from "../../hooks/useOrdersHook";
import {
    CFlexCenter,
    CFlexStart,
    DText,
    FlexCenter,
    FlexEnd,
    FlexStart,
    Padding,
    ScrollWrap
} from "../../styles/CommonStyles";
import {CoinWrap, OrderRow} from "../../styles/responsive/CommonStyles";
import {SOCKET_URL} from "../../constants/urls";
import Text from "../../utils/Text";
import {formatDate, formatNumber} from "../../utils/common";
import { OrdersBody } from "../../styles/OrdersStyle";
import {useMainContext} from "../../contexts/main";
import FilterLayout from "../../layouts/FilterLayout";
import RFilterLayout from "./RFilterLayout";


const RHistory = () => {

    const { main: { lang} } = useMainContext()
    const {
        orders, allPages,
        filterQueries, setFilterQueries, initialState, isFetching
    } = useOrdersHistory()

    return (
        <OrdersBody>
            <RFilterLayout
                headers={[]}
                data={orders}
                totalPages={allPages}
                state={{ filterQueries, setFilterQueries, initialState }}
                loading={isFetching}
                filters={['date', 'type']}
            >
                <ScrollWrap height="250px">
                    {orders ?
                        orders.data.map(order => (
                            <OrderRow>
                                <Padding padding="10px 15px">
                                    <CFlexCenter width="10%">
                                        <FlexCenter height="32px" style={{ position: "relative" }}>
                                            <CoinWrap left="20%">
                                                <img src={
                                                    SOCKET_URL +
                                                    `assets/icon/${order?.order?.coin?.toLowerCase()}.png`}
                                                     width="24px"
                                                     alt=" "
                                                />
                                            </CoinWrap>
                                            <CoinWrap left="60%" top="4px">
                                                <img src={
                                                    order.pair !== "irt" ?
                                                        SOCKET_URL +
                                                        `assets/icon/${order?.pair?.toLowerCase()}.png`
                                                        :
                                                        require("../../assets/images/tooman.png")
                                                }
                                                     width = "24px"
                                                     alt=" "
                                                />
                                            </CoinWrap>
                                        </FlexCenter>
                                        <FlexCenter>
                                            <DText fontSize="0.8rem">{order.order?.coin?.toUpperCase()}/{order.pair?.toUpperCase()}</DText>
                                        </FlexCenter>
                                    </CFlexCenter>

                                    <FlexEnd>
                                        <CFlexStart width="20%">
                                            <FlexStart><DText><Text tid="amount" />:</DText></FlexStart>
                                            <FlexStart><DText><Text tid="priceUnit" />:</DText></FlexStart>
                                            <FlexStart><DText><Text tid="price" />:</DText></FlexStart>
                                        </CFlexStart>
                                    </FlexEnd>
                                    <CFlexStart width="20%">
                                        <FlexStart>
                                            <DText
                                                fontSize="0.8rem"
                                                color={order.order.type === "buy" ? "#1ce087" : "#e9106c"}
                                            >
                                                {formatNumber(order.amount, 6)}
                                            </DText>
                                        </FlexStart>
                                        <FlexStart><DText>{formatNumber(order.priceUnit)}</DText></FlexStart>
                                        <FlexStart><DText>{formatNumber(order.price)}</DText></FlexStart>
                                    </CFlexStart>
                                    <CFlexStart>
                                        <DText
                                            fontSize="0.8rem"
                                            color={order.order.type === "buy" ? "#1ce087" : "#e9106c"}
                                        >
                                            <Text tid={order.order.type} />
                                        </DText>
                                        <DText>
                                            {formatDate(order.createdAt, "date", lang === "en" ? "en-US" : "fa-IR")}
                                        </DText>
                                        <DText>
                                            {formatDate(order.createdAt, "time", lang === "en" ? "en-US" : "fa-IR")}
                                        </DText>
                                    </CFlexStart>
                                </Padding>
                            </OrderRow>
                        )):null
                    }
                </ScrollWrap>
            </RFilterLayout>
        </OrdersBody>
    )
}

export default RHistory;
